import React, { useEffect, useState } from "react";
import AddShipmentItemButton from "../AddShipmentItemButton";
import ShipmentItemsTable from "../ShipmentItemsTable";

import style from "../../../../sass/pages/shipment/shipment.module.scss";
import { validators } from "../../../../validators/validators";
import DeleteShipmentBoxButton from "./DeleteShipmentBoxButton";
import { useDispatch, useSelector } from "react-redux";
import { selectShipment } from "../../shipmentSlice";
import {
    selectBoxHasUpdated,
    selectUpdatedBoxID,
    setBoxHasUpdated,
    updateShipmentBox,
} from "../shipmentItemsSlice";
import { useTranslation } from "react-i18next";

const ShipmentBoxItem = ({ box, index }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const shipment = useSelector(selectShipment);
    const updatedBoxID = useSelector(selectUpdatedBoxID);
    const boxHasUpdated = useSelector(selectBoxHasUpdated);

    const [sizesState, setSizesState] = useState({
        length: box.length === 0 ? "" : box.length,
        width: box.width === 0 ? "" : box.width,
        height: box.height === 0 ? "" : box.height,
        weight: box.weight === 0 ? "" : box.weight,
    });

    const [sizesHasChanged, setSizesHasChanged] = useState(false);

    useEffect(() => {
        setSizesState({
            length: box.length === 0 ? "" : box.length,
            width: box.width === 0 ? "" : box.width,
            height: box.height === 0 ? "" : box.height,
            weight: box.weight === 0 ? "" : box.weight.toFixed(2) * 1,
        });
    }, [box]);

    const setLength = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                length: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            setSizesHasChanged(false);
            return;
        }
        setSizesHasChanged(true);
        setSizesState((prev) => ({
            ...prev,
            length: +value,
        }));
    };
    const setWidth = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                width: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            setSizesHasChanged(false);
            return;
        }
        setSizesHasChanged(true);
        setSizesState((prev) => ({
            ...prev,
            width: +value,
        }));
    };
    const setHeight = (value) => {
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                height: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            setSizesHasChanged(false);
            return;
        }
        setSizesHasChanged(true);
        setSizesState((prev) => ({
            ...prev,
            height: +value,
        }));
    };
    const setWeight = (value) => {
        value = value.toString().replace(",", ".");
        if (!value) {
            setSizesState((prev) => ({
                ...prev,
                weight: "",
            }));
        }
        let err = validators.ValidateNumber(value);
        if (err !== null) {
            return;
        }
        setSizesHasChanged(true);
        setSizesState((prev) => ({
            ...prev,
            weight: value,
        }));
    };

    const handleUpdateSizesClick = () => {
        let lengthErr = validators.ValidateNumber(sizesState.length);
        let widthErr = validators.ValidateNumber(sizesState.width);
        let heightErr = validators.ValidateNumber(sizesState.height);

        if (lengthErr != null || widthErr != null || heightErr != null) return;

        if (!shipment.id || !box.id) {
            return;
        }

        dispatch(
            updateShipmentBox({
                shipmentID: shipment.id,
                boxID: box.id,
                sizes: sizesState,
            })
        );
    };

    useEffect(() => {
        if (!boxHasUpdated) {
            return;
        }

        if (updatedBoxID === box.id) {
            setSizesHasChanged(false);
            dispatch(setBoxHasUpdated(false));
        }
    }, [box.id, updatedBoxID, boxHasUpdated, dispatch]);

    if (!box || !box.id) {
        return <></>;
    }

    console.log(sizesState);

    return (
        <div>
            {
                shipment && !shipment["bill-id"] &&
                <div className="flex gap-x-8 gap-y-1 items-center text-xl text-left font-bold mb-2 flex-wrap">
                    <span>
                        {t("shipment.items.place.title")} {index}
                    </span>
                    <div className="flex flex-row gap-1 items-center font-medium text-base">
                        <span>
                            {t("shipment.items.place.approximate_weight")}: 
                        </span>
                        <input
                            className={`${style.input} text-2xs font-normal`}
                            type="text"
                            placeholder={t("shipment.items.place.weight")}
                            style={{ width: 80 }}
                            value={sizesState.weight}
                            onInput={(e) => setWeight(e.target.value)}
                        />
                        <div
                            className="flex flex-col"
                            style={{
                                height: 34,
                                gap: 2,
                            }}
                        >
                            <span
                                className="bg-gray-300 hover:bg-gray-400 font-normal px-2 cursor-pointer"
                                style={{
                                    height: 15,
                                    fontSize: 8,
                                    borderRadius: 3,
                                }}
                                onClick={() => setWeight(
                                    (+(sizesState.weight) + 0.1)
                                        .toFixed(2) * 1
                                )}
                            >
                                &#9650;
                            </span>
                            <span
                                className="bg-gray-300 hover:bg-gray-400 font-normal px-2 cursor-pointer"
                                style={{
                                    height: 15,
                                    fontSize: 8,
                                    borderRadius: 3,
                                }}
                                onClick={() => setWeight(
                                    (+(sizesState.weight) - 0.1)
                                        .toFixed(2) * 1
                                )}
                            >
                                &#9660;
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-row gap-1">
                        <input
                            className={`${style.input} text-2xs font-normal`}
                            value={sizesState.height}
                            type="text"
                            placeholder={t("shipment.items.place.height")}
                            style={{ width: 80 }}
                            onInput={(e) => setHeight(e.target.value)}
                        />
                        <span className="font-normal">*</span>
                        <input
                            className={`${style.input} text-2xs font-normal`}
                            type="text"
                            placeholder={t("shipment.items.place.width")}
                            style={{ width: 80 }}
                            value={sizesState.width}
                            onInput={(e) => setWidth(e.target.value)}
                        />
                        <span className="font-normal">*</span>
                        <input
                            className={`${style.input} text-2xs font-normal`}
                            type="text"
                            placeholder={t("shipment.items.place.length")}
                            style={{ width: 80 }}
                            value={sizesState.length}
                            onInput={(e) => setLength(e.target.value)}
                        />
                    </div>
                    <span className="font-medium text-base">
                        {t("shipment.items.place.volume_weight")}:{" "}
                        <span className="font-normal">
                            {(
                                (sizesState.height *
                                    sizesState.width *
                                    sizesState.length) /
                                5000
                            ).toFixed(2)}
                        </span>
                    </span>
                    {sizesHasChanged && (
                        <div
                            className={`${style.btn} ${style["btn-primary"]} p-2 text-xs`}
                            onClick={handleUpdateSizesClick}
                        >
                            {t("shipment.items.place.save_button")}
                        </div>
                    )}
                </div>
            }

            <div className="px-2 sm:px-4">
                <ShipmentItemsTable items={box.items} boxID={box.id} />
                {
                    shipment && !shipment.blocked &&
                    <div className="flex gap-x-4 mt-6">
                        <div>
                            <AddShipmentItemButton boxID={box.id} />
                        </div>
                        <div>
                            <DeleteShipmentBoxButton boxID={box.id} />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default ShipmentBoxItem;
